// extracted by mini-css-extract-plugin
export default {"Line":"ColoredCategory_Line__vYg+C","Name":"ColoredCategory_Name__TKOCi"};